import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import styles from "./styles"
import Typography from "@material-ui/core/Typography"
import { setVisibility } from "../../actions/message-drawer"
import MainAppBar from "../../components/MainAppBar"
import crewMamaLogo from "../../assets/images/crewmama_brand.png"

class NotFound extends Component {
  componentDidMount() {
    this.props.dispatch(setVisibility(false))
  }
  componentWillUnmount() {
    this.props.dispatch(setVisibility(true))
  }
  render() {
    const { classes } = this.props
    return (
      <Fragment>
        <MainAppBar />
        <section className={classes.notFound}>
          <img
            src={crewMamaLogo}
            alt="Crew Mama Logo"
            className={classes.notFoundImg}
          />
          <div className={classes.text}>
            <Typography variant="display3" className={classes.display}>
              404 - Page Not Found
            </Typography>
            <Typography variant="subtitle1" style={{ marginTop: "20px" }}>
              Sorry about that, check the URL and make sure you didn't make a
              mistake, or refresh and try again
            </Typography>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default compose(
  connect(),
  withStyles(styles)
)(NotFound)
